module.exports = __webpack_public_path__ + "officialStatic/img/product-jwzw.4f7d553.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-jwzw.png
// module id = HFrU
// module chunks = 0